<template>
    <div v-if="promotions.length" class="d-flex flex-column justify-center">
        <h3 class="font-weight-light text-center">Promociones</h3>
        <v-chip-group outlined v-if="!$vuetify.breakpoint.smAndDown">
            <v-chip
                v-for="(promo, index) in promotions" 
                :key="index" 
                :color="isActive(promo.metadataInfo.deactivationDate) ? 'success' : 'red darken-3'"
                outlined 
                class="pa-6"
            >
                <div class="d-flex flex-column">
                    <div>
                        {{ promo.description }}
                    </div>
                    <div class="text-center">
                        {{ formatDate(promo.metadataInfo.activationDate) }} 
                        <v-icon small>
                            mdi-arrow-right
                        </v-icon>
                        <span v-if="promo.metadataInfo.deactivationDate">
                            {{ formatDate(promo.metadataInfo.deactivationDate) }}
                        </span>
                        <v-icon
                            v-else
                            small
                        >
                            mdi-infinity
                        </v-icon>
                    </div>
                </div>
            </v-chip>
        </v-chip-group>
        <div v-else class="d-flex flex-column">
            <v-chip
                v-for="(promo, index) in promotions" 
                :key="index" 
                :color="isActive(promo.metadataInfo.deactivationDate) ? 'success' : 'red darken-3'"
                outlined 
                class="pa-6 my-1 d-flex justify-center"
            >
                <div class="d-flex flex-column justify-center">
                    <div>
                        {{ promo.description }}
                    </div>
                    <div class="text-center">
                        {{ formatDate(promo.metadataInfo.activationDate) }} 
                        <v-icon small>
                            mdi-arrow-right
                        </v-icon>
                        <span v-if="promo.metadataInfo.deactivationDate">
                            {{ formatDate(promo.metadataInfo.deactivationDate) }}
                        </span>
                        <v-icon
                            v-else
                            small
                        >
                            mdi-infinity
                        </v-icon>
                    </div>
                </div>
            </v-chip>
        </div>
    </div>
    <h3 class="font-weight-light grey--text text-center" v-else>No hay promociones activas</h3>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate } from '@/util/libUtil.js';

export default {
    data: () => ({
        promotions: []
    }),
    props: {
        serviceID: {
            type: String,
        },
        serviceType: {
            type: String,
        },
        selectedContractId: {
            type: String,
        },
    },
    computed: {
        ...mapState('agent', {
            agentCustInfo: (state) => state.agentCustInfo,
        }),
    },
    methods: {
        formatDate,
        isActive(date) {
            return !date || new Date(date) > new Date();
        }
    },
    mounted() {
        let promos = [];

        for (const [account_id, account] of Object.entries(this.agentCustInfo)) {
            const contract = account[this.selectedContractId];
            const all_promotions = contract.promotions.data.account;
            const promotype = all_promotions[this.serviceType];

            if (this.serviceType === 'landlineSubscriptions') {
                Object.values(all_promotions.broadbandSubscriptions).forEach(({promotions}) => {
                    promos = [...promos, ...Object.values(promotions)];
                });
                Object.values(all_promotions.bundles).forEach(({promotions}) => {
                    promos = [...promos, ...Object.values(promotions)];
                });
            }

            for (const [num, promo] of Object.entries(promotype)) {
                if(promo.id === this.serviceID) {
                    promos = [...promos, ...promo.promotions]
                }
            }
        }

        this.promotions = promos.sort((a, b) => {
            if (!a.metadataInfo.deactivationDate && !b.metadataInfo.deactivationDate) return 0;
            if (!a.metadataInfo.deactivationDate) return -1;
            if (!b.metadataInfo.deactivationDate) return 1;

            const dateA = new Date(a.metadataInfo.deactivationDate).getTime();
            const dateB = new Date(b.metadataInfo.deactivationDate).getTime();

            return dateB - dateA;
        });
    },
}
</script>